// @flow
import { createCharity, updateCharity } from './actions'
import { reduxForm } from 'redux-form'
import { compose, withProps } from 'recompose'
import CharityLocationForm from '../../ui/forms/charity-location-form'
import { validateCharityLocation } from '../validations/locations'
import withLocationFormTranslations from '../mycharity/charity/withLocationFormTranslations'

const withCharityData = withProps(props => ({
  initialValues: {
    location: props.charity ? props.charity.location : null,
    lat: props.charity ? props.charity.lat : null,
    lng: props.charity ? props.charity.lng : null,
    country: props.charity ? props.charity.country : null,
    countryCode: props.charity ? props.charity.countryCode : null
  }
}))

const withForm = reduxForm({
  form: 'register-charity-location',
  enableReinitialize: true,
  validate: validateCharityLocation,
  onSubmit(values, dispatch, props) {
    const thunk = props.userCharityId
      ? updateCharity(values)
      : createCharity(values)
    return dispatch(thunk)
      .then(() => {
        props.onNext()
      })
      .catch(error => {
        console.log('Submit failed', error)
      })
  }
})

const withHandleCancel = withProps(props => {
  return {
    handleCancel(e) {
      props.onBack(e)
    }
  }
})

export const decorator = compose(
  withCharityData,
  withForm,
  withHandleCancel,
  withLocationFormTranslations
)

export default decorator(CharityLocationForm)



// WEBPACK FOOTER //
// ./src/services/register-charity/Location.js